import { g as V } from "../_commonjsHelpers-C6fGbg64.js";
import { useState as z, useEffect as T, useRef as k } from "react";
var m = {}, j = {}, _ = {}, C = {};
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */
var R;
function G() {
  if (R) return C;
  R = 1, C.parse = l, C.serialize = c;
  var t = Object.prototype.toString, e = Object.prototype.hasOwnProperty, o = /^[!#$%&'*+\-.^_`|~0-9A-Za-z]+$/, n = /^("?)[\u0021\u0023-\u002B\u002D-\u003A\u003C-\u005B\u005D-\u007E]*\1$/, i = /^([.]?[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)([.][a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*$/i, r = /^[\u0020-\u003A\u003D-\u007E]*$/;
  function l(s, v) {
    if (typeof s != "string")
      throw new TypeError("argument str must be a string");
    var a = {}, p = s.length;
    if (p < 2) return a;
    var w = v && v.decode || h, d = 0, b = 0, S = 0;
    do {
      if (b = s.indexOf("=", d), b === -1) break;
      if (S = s.indexOf(";", d), S === -1)
        S = p;
      else if (b > S) {
        d = s.lastIndexOf(";", b - 1) + 1;
        continue;
      }
      var O = f(s, d, b), E = u(s, b, O), A = s.slice(O, E);
      if (!e.call(a, A)) {
        var M = f(s, b + 1, S), $ = u(s, S, M);
        s.charCodeAt(M) === 34 && s.charCodeAt($ - 1) === 34 && (M++, $--);
        var H = s.slice(M, $);
        a[A] = y(H, w);
      }
      d = S + 1;
    } while (d < p);
    return a;
  }
  function f(s, v, a) {
    do {
      var p = s.charCodeAt(v);
      if (p !== 32 && p !== 9) return v;
    } while (++v < a);
    return a;
  }
  function u(s, v, a) {
    for (; v > a; ) {
      var p = s.charCodeAt(--v);
      if (p !== 32 && p !== 9) return v + 1;
    }
    return a;
  }
  function c(s, v, a) {
    var p = a && a.encode || encodeURIComponent;
    if (typeof p != "function")
      throw new TypeError("option encode is invalid");
    if (!o.test(s))
      throw new TypeError("argument name is invalid");
    var w = p(v);
    if (!n.test(w))
      throw new TypeError("argument val is invalid");
    var d = s + "=" + w;
    if (!a) return d;
    if (a.maxAge != null) {
      var b = Math.floor(a.maxAge);
      if (!isFinite(b))
        throw new TypeError("option maxAge is invalid");
      d += "; Max-Age=" + b;
    }
    if (a.domain) {
      if (!i.test(a.domain))
        throw new TypeError("option domain is invalid");
      d += "; Domain=" + a.domain;
    }
    if (a.path) {
      if (!r.test(a.path))
        throw new TypeError("option path is invalid");
      d += "; Path=" + a.path;
    }
    if (a.expires) {
      var S = a.expires;
      if (!g(S) || isNaN(S.valueOf()))
        throw new TypeError("option expires is invalid");
      d += "; Expires=" + S.toUTCString();
    }
    if (a.httpOnly && (d += "; HttpOnly"), a.secure && (d += "; Secure"), a.partitioned && (d += "; Partitioned"), a.priority) {
      var O = typeof a.priority == "string" ? a.priority.toLowerCase() : a.priority;
      switch (O) {
        case "low":
          d += "; Priority=Low";
          break;
        case "medium":
          d += "; Priority=Medium";
          break;
        case "high":
          d += "; Priority=High";
          break;
        default:
          throw new TypeError("option priority is invalid");
      }
    }
    if (a.sameSite) {
      var E = typeof a.sameSite == "string" ? a.sameSite.toLowerCase() : a.sameSite;
      switch (E) {
        case !0:
          d += "; SameSite=Strict";
          break;
        case "lax":
          d += "; SameSite=Lax";
          break;
        case "strict":
          d += "; SameSite=Strict";
          break;
        case "none":
          d += "; SameSite=None";
          break;
        default:
          throw new TypeError("option sameSite is invalid");
      }
    }
    return d;
  }
  function h(s) {
    return s.indexOf("%") !== -1 ? decodeURIComponent(s) : s;
  }
  function g(s) {
    return t.call(s) === "[object Date]";
  }
  function y(s, v) {
    try {
      return v(s);
    } catch {
      return s;
    }
  }
  return C;
}
var L;
function F() {
  if (L) return _;
  L = 1, Object.defineProperty(_, "__esModule", {
    value: !0
  });
  var t = /* @__PURE__ */ function() {
    function u(c, h) {
      for (var g = 0; g < h.length; g++) {
        var y = h[g];
        y.enumerable = y.enumerable || !1, y.configurable = !0, "value" in y && (y.writable = !0), Object.defineProperty(c, y.key, y);
      }
    }
    return function(c, h, g) {
      return h && u(c.prototype, h), g && u(c, g), c;
    };
  }();
  _.hasCookies = f;
  var e = G(), o = n(e);
  function n(u) {
    return u && u.__esModule ? u : { default: u };
  }
  function i(u, c) {
    if (!(u instanceof c))
      throw new TypeError("Cannot call a class as a function");
  }
  var r = "lS_", l = function() {
    function u() {
      var c = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      i(this, u), this.cookieOptions = Object.assign({ path: "/" }, c), r = c.prefix === void 0 ? r : c.prefix;
    }
    return t(u, [{
      key: "getItem",
      value: function(h) {
        var g = o.default.parse(document.cookie);
        return !g || !g.hasOwnProperty(r + h) ? null : g[r + h];
      }
    }, {
      key: "setItem",
      value: function(h, g) {
        return document.cookie = o.default.serialize(r + h, g, this.cookieOptions), g;
      }
    }, {
      key: "removeItem",
      value: function(h) {
        var g = Object.assign({}, this.cookieOptions, { maxAge: -1 });
        return document.cookie = o.default.serialize(r + h, "", g), null;
      }
    }, {
      key: "clear",
      value: function() {
        var h = o.default.parse(document.cookie);
        for (var g in h)
          g.indexOf(r) === 0 && this.removeItem(g.substr(r.length));
        return null;
      }
    }]), u;
  }();
  _.default = l;
  function f() {
    var u = new l();
    try {
      var c = "__test";
      u.setItem(c, "1");
      var h = u.getItem(c);
      return u.removeItem(c), h === "1";
    } catch {
      return !1;
    }
  }
  return _;
}
var U;
function J() {
  if (U) return j;
  U = 1, Object.defineProperty(j, "__esModule", {
    value: !0
  }), j.default = n;
  var t = F(), e = "__test";
  function o(i) {
    try {
      var r = window[i];
      return r.setItem(e, "1"), r.removeItem(e), !0;
    } catch {
      return !1;
    }
  }
  function n() {
    var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "localStorage", r = String(i).replace(/storage$/i, "").toLowerCase();
    if (r === "local")
      return o("localStorage");
    if (r === "session")
      return o("sessionStorage");
    if (r === "cookie")
      return (0, t.hasCookies)();
    if (r === "memory")
      return !0;
    throw new Error("Storage method `" + i + "` is not available.\n    Please use one of the following: localStorage, sessionStorage, cookieStorage, memoryStorage.");
  }
  return j;
}
var I = {}, D;
function Z() {
  if (D) return I;
  D = 1, Object.defineProperty(I, "__esModule", {
    value: !0
  });
  var t = /* @__PURE__ */ function() {
    function n(i, r) {
      for (var l = 0; l < r.length; l++) {
        var f = r[l];
        f.enumerable = f.enumerable || !1, f.configurable = !0, "value" in f && (f.writable = !0), Object.defineProperty(i, f.key, f);
      }
    }
    return function(i, r, l) {
      return r && n(i.prototype, r), l && n(i, l), i;
    };
  }();
  function e(n, i) {
    if (!(n instanceof i))
      throw new TypeError("Cannot call a class as a function");
  }
  var o = function() {
    function n() {
      e(this, n), this._data = {};
    }
    return t(n, [{
      key: "getItem",
      value: function(r) {
        return this._data.hasOwnProperty(r) ? this._data[r] : null;
      }
    }, {
      key: "setItem",
      value: function(r, l) {
        return this._data[r] = String(l);
      }
    }, {
      key: "removeItem",
      value: function(r) {
        return delete this._data[r];
      }
    }, {
      key: "clear",
      value: function() {
        return this._data = {};
      }
    }]), n;
  }();
  return I.default = o, I;
}
var q;
function Q() {
  if (q) return m;
  q = 1, Object.defineProperty(m, "__esModule", {
    value: !0
  }), m.MemoryStorage = m.CookieStorage = m.isSupported = m.storage = void 0;
  var t = J(), e = l(t), o = F(), n = l(o), i = Z(), r = l(i);
  function l(u) {
    return u && u.__esModule ? u : { default: u };
  }
  var f = null;
  return (0, e.default)("localStorage") ? m.storage = f = window.localStorage : (0, e.default)("sessionStorage") ? m.storage = f = window.sessionStorage : (0, e.default)("cookieStorage") ? m.storage = f = new n.default() : m.storage = f = new r.default(), m.default = f, m.storage = f, m.isSupported = e.default, m.CookieStorage = n.default, m.MemoryStorage = r.default, m;
}
var W = Q();
const X = /* @__PURE__ */ V(W);
class N {
  constructor(e = "global") {
    this.group = e, this.localStorage = X;
  }
  /**
   * Sets the group under which to save a value.
   *
   * E.g. as a group of "global" and a key of "thing", the location
   * in storage would be "global.thing"
   *
   * @param group Unique key to group under
   */
  setGroup(e) {
    this.group = e;
  }
  /**
   * @returns Currently set group name
   */
  getGroup() {
    return this.group;
  }
  /**
   * Returns a value stored in storage
   *
   * @param key The key under the group "group.key"
   * @returns String value saved under "group.key"
   */
  getItem(e) {
    return this.localStorage.getItem(`${this.group}.${e}`);
  }
  /**
   * Saves a new value in storage
   *
   * @param key The key under the group "group.key"
   * @param value String value to save
   */
  setItem(e, o) {
    this.localStorage.setItem(`${this.group}.${e}`, o);
  }
  /**
   * Removes a stored value
   *
   * @param key The key under the group "group.key"
   */
  removeItem(e) {
    this.localStorage.removeItem(`${this.group}.${e}`);
  }
}
class K {
  constructor() {
    this.storageLocation = "suggestion_history", this.history = [], this.storage = new N("commute");
    const e = this.storage.getItem(this.storageLocation);
    e && (this.history = JSON.parse(e));
  }
  /**
   * Pushes the new suggestion to the top of the array. If it's a
   * duplicate (based on the locationId), it will remove the duplicate(s)
   *
   * @param suggestion Address suggestion object including locationId and address object
   */
  push(e) {
    this.history = this.removeDuplicateEntries(e), this.history.unshift(e), this.history.length > 5 && (this.history = this.history.slice(0, 5)), this.storage.setItem(this.storageLocation, JSON.stringify(this.history));
  }
  /**
   * Indicates whether there are suggestions saved in history
   *
   * @returns boolean
   */
  hasSuggestionHistory() {
    return this.history.length > 0;
  }
  /**
   * Returns the array of address suggestions from local storage
   *
   * @returns Array of address suggestions (only locationId and address object)
   */
  getSuggestionHistory() {
    return this.history;
  }
  removeDuplicateEntries(e) {
    return this.history.filter((o) => o.locationId !== e.locationId);
  }
}
const Y = new K(), ee = ({
  data: t,
  fileName: e,
  fileType: o
}) => {
  const n = `text/${o}`, i = new Blob([t], { type: n }), r = document.createElement("a");
  r.download = `${e}.${o}`, r.href = window.URL.createObjectURL(i);
  const l = new MouseEvent("click", {
    view: window,
    bubbles: !0,
    cancelable: !0
  });
  r.dispatchEvent(l), r.remove();
}, te = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  downloadFile: ee
}, Symbol.toStringTag, { value: "Module" })), _e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BrowserStorage: N,
  commuteHistory: Y,
  file: te
}, Symbol.toStringTag, { value: "Module" })), re = (t, e) => {
  const [o, n] = z(t);
  return T(
    () => {
      const i = setTimeout(() => {
        n(t);
      }, e);
      return () => {
        clearTimeout(i);
      };
    },
    [t, e]
    // Only re-call effect if value or delay changes
  ), o;
}, oe = (t) => {
  const e = k(t), o = k(), n = k(!1), i = k(!1), [, r] = z(0);
  n.current && (i.current = !0), T(() => (n.current || (o.current = e.current(), n.current = !0), r((l) => l + 1), () => {
    i.current && o.current && o.current();
  }), []);
}, ne = () => {
  const [t, e] = z(!0);
  return T(() => {
    e(!1);
  }, []), t;
}, we = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  useDebounce: re,
  useEffectOnce: oe,
  useIsSSR: ne
}, Symbol.toStringTag, { value: "Module" })), ie = "0123456789bcdefghjkmnpqrstuvwxyz";
function ae(t) {
  if (!t?.length)
    throw new Error("Invalid geohash");
  const e = t.toLowerCase();
  let o = !0, n = -90, i = 90, r = -180, l = 180;
  for (let u = 0; u < e.length; u++) {
    const c = e.charAt(u), h = ie.indexOf(c);
    if (h === -1)
      throw new Error("Invalid geohash");
    for (let g = 4; g >= 0; g--) {
      const y = h >> g & 1;
      if (o) {
        const s = (r + l) / 2;
        y === 1 ? r = s : l = s;
      } else {
        const s = (n + i) / 2;
        y === 1 ? n = s : i = s;
      }
      o = !o;
    }
  }
  return {
    sw: { lat: n, lng: r },
    ne: { lat: i, lng: l }
  };
}
function B(t) {
  const e = ae(t), o = e.sw.lat, n = e.sw.lng, i = e.ne.lat, r = e.ne.lng;
  let l = (o + i) / 2, f = (n + r) / 2;
  return l = Number(l.toFixed(Math.floor(2 - Math.log(i - o) / Math.LN10))), f = Number(f.toFixed(Math.floor(2 - Math.log(r - n) / Math.LN10))), { lat: l, lng: f };
}
function se(t) {
  const e = t.split("_");
  if (e.length < 2)
    throw new Error("Invalid geogId");
  return B(e[1]);
}
function ue(t = []) {
  const e = (i) => Object.values(i).map((r) => Array.isArray(r[0]) ? e(r) : [r[1], r[0]]);
  return {
    type: "FeatureCollection",
    features: [
      {
        id: "schoolCatchment",
        type: "Feature",
        geometry: {
          type: "MultiPolygon",
          coordinates: e(t)
        }
      }
    ]
  };
}
function le(t) {
  return {
    type: "FeatureCollection",
    features: [
      {
        id: "route",
        type: "Feature",
        geometry: t
      }
    ]
  };
}
const Oe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decodeGeogId: se,
  decodeGeohash: B,
  formatGeometry: ue,
  formatMapBoxGeoJson: le
}, Symbol.toStringTag, { value: "Module" })), ce = (t, e = "en-US", o = "USD", n = 0) => new Intl.NumberFormat(e, { style: "currency", currency: o, maximumFractionDigits: n }).format(
  t ?? 0
), fe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  formatCurrency: ce
}, Symbol.toStringTag, { value: "Module" })), x = (t) => typeof t == "object" && t !== null && !Array.isArray(t);
function P(t, ...e) {
  if (!e.length) return t;
  const o = e.shift();
  return x(t) && x(o) && Object.keys(o).forEach((n) => {
    x(o[n]) ? (t[n] || Object.assign(t, { [n]: {} }), P(t[n], o[n])) : Object.assign(t, { [n]: o[n] });
  }), P(t, ...e);
}
const ge = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  isObject: x,
  mergeDeep: P
}, Symbol.toStringTag, { value: "Module" })), de = (t, e, o) => e === 1 ? t : o ?? `${t}s`, he = (t) => t.charAt(0).toUpperCase() + t.slice(1), me = ({
  houseNumber: t,
  street: e,
  city: o,
  state: n,
  country: i,
  postalCode: r,
  description: l
}) => [`${t ? `${t && e ? `${t} ` : `${t}`}` : ""}${e || ""}`, o, n, i, r].reduceRight((u, c) => u && c ? `${c}, ${u}` : c || u || "") || "", ve = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  capitalize: he,
  formatAddress: me,
  pluralize: de
}, Symbol.toStringTag, { value: "Module" })), Me = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  number: fe,
  object: ge,
  string: ve
}, Symbol.toStringTag, { value: "Module" })), ye = (t, e) => e === "school", pe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  isSchool: ye
}, Symbol.toStringTag, { value: "Module" })), ke = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  poi: pe
}, Symbol.toStringTag, { value: "Module" }));
export {
  _e as browserUtils,
  we as hookUtils,
  Oe as mapUtils,
  Me as primitiveUtils,
  ke as typeguardUtils
};
